import { SITE, BUILD_YEAR } from "@/content/site";
import { FOOTER_COLUMNS } from "@/content/footer.mjs";

// "Semrush vs SEO Signals" breaks after "vs" so "SEO Signals" stays on one line.
const label = name => {
  const m = name.match(/^(.+ vs) (SEO Signals)$/);
  return m ? <>{m[1]}{" "}<br />{m[2]}</> : name;
};

export default function SiteFooter() {
  return <footer className="ss-footer"><div className="ss-container ss-footer-grid">
    <div className="ss-footer-about"><a className="ss-footer-brand" href="/">SEO Signals</a><p>{SITE.descriptor}</p><p>Less reporting. More progress.</p><p>{`Run by ${SITE.operator}, ${SITE.locality}, UK.`}</p><a href={`mailto:${SITE.contactEmail}`} data-testid="footer-contact">{SITE.contactEmail}</a><small>© {BUILD_YEAR} SEO Signals</small></div>
    {FOOTER_COLUMNS.map(col => <nav key={col.title} aria-label={col.title}><h2>{col.title}</h2>{col.items.map(item => item.href
      ? <a key={item.name} href={item.href}>{label(item.name)}</a>
      : <span key={item.name} className="ss-footer-soon">{item.name}<span className="ss-footer-badge">Coming soon</span></span>)}</nav>)}
  </div></footer>;
}
